<template>
  <div>
    <v-navigation-drawer v-model="drawer"  fixed app class="nav-bar darken-1" width="300">
      <!-- logotipo do sistema -->
      <v-app-bar class="nav-bar darken-2" style="position: fixed; z-index: 888;" >
        <div class="app-nav">
          <img src="../assets/imagens/logo_mono_cp.png" width="53%" />
        </div>
      </v-app-bar>
      <!-- fim do logotipo do sistema -->
      <!-- Área de exibição de dados do usuário logado -->
      <v-main class="pa-1" style="margin-top: 64px;">
        <v-list dark>
          <v-list-item>
            <v-list-item-avatar size="45">
              <img :src="avatar" alt="Sua Foto" class="border-avatar" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title  class="font-weight-bold text-caption text-uppercase m-0" >
                {{username}}
              </v-list-item-title>
              <v-list-item-subtitle class="font-weight-small text-caption">{{profile_name}}</v-list-item-subtitle>
              <v-list-item-subtitle class="font-weight-small text-caption" :title="schoolName">{{schoolName}}</v-list-item-subtitle>
              <v-list-item-subtitle class="font-weight-small text-caption" :title="getAnoSistema">{{getAnoSistema}}</v-list-item-subtitle>
            </v-list-item-content>

            <!--Ícone engrenagem Alterar perfil -->
            <v-list-item-action>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :close-on-click="false"
                :nudge-width="200"
                offset-x
              >
                <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="desabilitarBotaoSettingsPerfil"
                      text
                      icon
                      v-on="on"
                      @click="alterarAcesso"
                      title="Alterar Perfil"
                    >
                      <v-icon medium>settings</v-icon>
                    </v-btn>
                </template>
                  <v-card>
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Alterar Perfil</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-divider></v-divider>

                    <v-list style="width: 360px;" class="px-4" >
                      <v-list-item-title class="mt-2">
                        <Select
                          label="Perfis"
                          :options="optionsPerfis"
                          v-model="perfilEscolhido"
                          :v="$v.perfilEscolhido"
                          style="width:100%;"
                        />
                      </v-list-item-title>
                      <v-list-item-title class="h-5" max-height="50px">
                        <Select
                          v-show="exibirListaAno"
                          label="Ano"
                          :options="optionsAno"
                          v-model.number="anoEscolhido"
                          :v="$v.anoEscolhido"
                          @input="mudarAno"
                          style="width:100%"
                        />
                      </v-list-item-title>
                      <v-list-item-title v-if="exibir">
                        <Select
                          label="Escolas"
                          :options="optionsEscolas"
                          v-model="escolaEscolhido"
                          :v="$v.escolaEscolhido"
                          style="width:100%"
                        />
                      </v-list-item-title>
                    </v-list>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="rounded-sm font-weight-regular" text @click="cancelarMudarPerfil">Cancelar</v-btn>
                      <v-btn class="rounded-sm font-weight-regular" color="primary" text @click="onSubmit">Salvar</v-btn>
                    </v-card-actions>

                  </v-card>
              </v-menu>
            </v-list-item-action>
            <!--fim do Ícone engrenagem Alterar perfil -->
          </v-list-item>
        </v-list>
      </v-main>

      <!-- Fim área de exibição de dados do usuário logado -->
      <!-- início do menu -->
      <template>
        <!-- <v-card
          class="mx-auto"
          width="300"
        > -->
          <v-list dark style="padding-bottom: 64px !important;">
                <router-link to="/" tag="div" replace>
                  <v-list-item>
                        <v-list-item-icon >
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="text-body-2" >Início</v-list-item-title>
                  </v-list-item>
                </router-link>
                <v-divider></v-divider>

            <v-list-group
              :value="false"
              v-for="(nivel1, index) in userPerfilTelas"
              :key="index"
              class="nivel1"
              color="#FFF"
            >
              <template v-slot:activator>
                <v-list-item-title  color="#FFF" :title="nivel1.name" >{{ nivel1.name }}</v-list-item-title>
              </template>

                <div v-for="(nivel2, index) in nivel1.telas" :key="index">
                  <div  v-if="!nivel2.subTelas" class="subnivel" >
                    <router-link :to="nivel2.url || '' " tag="div" replace>
                      <v-list-item color="#FFF" style="height: 0;" >
                          <v-list-item-icon>
                              <v-icon>label</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title :title="nivel2.name" >{{nivel2.name}}</v-list-item-title>
                      </v-list-item>
                    </router-link>
                  </div>
                  <div v-else>
                    <v-list dark class="nivel" color="#5492c1">
                      <v-list-group
                        :value="false"
                        :key="index"
                        color="#FFF"

                      >
                        <template v-slot:activator >
                          <v-list-item-content class="ps-4 mb-0">
                            <v-list-item-title color="#FFF" :title="nivel2.name" >{{ nivel2.name }}</v-list-item-title>
                          </v-list-item-content>
                        </template>

                            <div v-for="(nivel3, index) in nivel2.subTelas" :key="index">
                              <div v-if="!nivel3.subTelas2" class="subnivel nivelBranco">
                                  <router-link :to="nivel3.url || '' " tag="div" replace>
                                    <v-list-item >
                                          <v-list-item-icon class="ps-4 me-4 mb-0">
                                              <v-icon color="#737373">label</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-title style="color: black;" :title="`${nivel3.name.replace(/\[#\d+\]/i, '')}`" v-text="`${nivel3.name.replace(/\[#\d+\]/i, '')}`"></v-list-item-title>
                                    </v-list-item>
                                  </router-link>
                              </div>
                              <div v-else>
                                <v-divider color="#84b5d6"></v-divider>
                                <v-list dark>
                                    <v-list-group
                                      color="#FFF"
                                    >
                                      <template v-slot:activator>
                                        <v-list-item-content class="ps-7">
                                          <v-list-item-title color="#FFF" :title="nivel3.name">{{ nivel3.name }}</v-list-item-title>
                                        </v-list-item-content>
                                      </template>

                                      <v-list-item
                                        v-for="(nivel4, index) in nivel3.subTelas2"
                                        :key="index"
                                        link
                                        class="subnivel nivelBranco"
                                        color="#FFF"
                                      >
                                        <router-link :to="nivel4.url || '' " tag="div" replace>
                                          <v-list-item >
                                                <v-list-item-icon class="ps-7 me-4 mb-0">
                                                    <v-icon color="#737373">label</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title style="color: black;" :title="nivel4.name" >{{ nivel4.name }}</v-list-item-title>

                                          </v-list-item>
                                        </router-link>

                                      </v-list-item>
                                    </v-list-group>
                                </v-list>

                              </div>




                            </div>


                      </v-list-group>

                    </v-list>

                  </div>



                </div>


            </v-list-group>
          </v-list>
        <!-- </v-card> -->
      </template>

      <!-- dim do menu -->

      <v-footer class="menu-footer">
        <div>{{ version }}</div>
      </v-footer>
    </v-navigation-drawer>
    <!-- barra do sistema com menu hamburguer, notificações e logout -->
    <v-app-bar color="nav-bar" style="z-index: 5;" dark fixed app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-spacer />
          <!-- <v-menu open-on-click offset-y left> -->
            <!-- <template v-slot:activator="{ on }"> -->
              <v-dialog v-model="modalatalhos" width="500px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon  v-on="on" v-bind="attrs">
                    <v-icon size="23px" style="margin-top: 2px;" color="white" title="Atalhos do sistema">keyboard</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="primary white--text">
                    Atalhos do sistema
                  </v-card-title>
                  <v-card-text class="pb-0 pt-6">
                      <p><span class="label_dialog">Alt + i =</span> Ir para tela Início</p>
                      <p><span class="label_dialog">Alt + c =</span> Ir para a tela Notas, Conceitos, Frequência, Parecer e Perfil</p>
                      <p><span class="label_dialog">Alt + s =</span> Sair do sistema</p>
                  </v-card-text>
                  <v-card-actions >
                  <v-spacer></v-spacer>
                      <v-btn
                       class="primary white--text mr-3 rounded-sm font-weight-regular"
                       @click="modalatalhos = false"
                       small
                      >
                        FECHAR
                      </v-btn>
                </v-card-actions>
                </v-card>

              </v-dialog>

          <v-btn v-if="userDadosPerfilAtual.identificadorperfil == 2" dark icon active-class="" @click="toggle = !toggle" :to="{ name: 'registro-notificacao', query: { c:toggle }, params: { buscarPendentes: true } }">
            <v-badge left overlap color="red" :value="quantidade_notificacoes > 0" >
              <template  v-slot:badge>
                    <span>{{quantidade_notificacoes}}</span>
              </template>
              <v-icon size="23px" style="margin-top: 2px;" color="white" title="Notificações">add_alert</v-icon>
            </v-badge>
          </v-btn>
          <v-menu open-on-click offset-y left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" dark icon aria-label="Pressione ALT+S para sair do sistema">
                <v-icon title="Sair do sistema">account_box</v-icon>
              </v-btn>
            </template>
              <v-list class="text-center p-4">
                <!-- <v-list-item v-for="item in itens" :key="item.title">
                  <v-list-item-title>{{item.title}}</v-list-item-title>
                </v-list-item> -->
                <v-list-item to="/logoff" >
                    <v-list-item-title>Sair</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
    </v-app-bar>
    <!-- final da barra do sistema -->
    <v-main>
      <v-container class="container_principal">
        <div>
          <BreadCrumb />
          <!-- <transition name="router-anim-layout" enter-active-class="animated fadeIn"> -->
          <keep-alive include="registronotificacao">
            <router-view :key="toggle" @update-notification="getQuantidadeNotificacoes()"></router-view>
          </keep-alive>
          <!-- </transition> -->
        </div>
      </v-container>
    </v-main>
    <vue-progress-bar></vue-progress-bar>
    <!-- area de conteúdo -->

    <!-- Fim da area de conteúdo -->


  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import BreadCrumb from "@/components/BreadCrumb";
import { required, requiredIf } from "vuelidate/lib/validators";
import router from '@/routes';

const AuthRepository = RepositoryFactory.get("auth");
const NotificacaoRepository = RepositoryFactory.get('notificacao');


document.addEventListener("keydown", function(event) {
  if(event.altKey && event.key === 's') {
    router.push('/logoff')
  }

  if(event.altKey && event.key === 'i') {
    router.push('/')
  }

  if(event.altKey && event.key === 'c') {
    router.push('/diario-escolar')
  }
})

export default {
  components: {
    // Gravatar,
    BreadCrumb
  },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    drawer: null,
    modalatalhos: false,
    items: [
      // { title: 'Minha Conta' },
      // { title: 'Configurações' },
    ],
    menu: false,
    desabilitarBotaoSettingsPerfil: false,
    escolaEscolhido: null,
    perfilEscolhido: null,
    anoEscolhido: null,
    escolas: [],
    exibir: false,
    quantidade_notificacoes: 0,
    toggle: false,

  }),
  created() {
    this.anoEscolhido = this.getAnoSistema;
    if ( this.userDadosPerfilAtual.identificadorperfil == 2 )
      this.getQuantidadeNotificacoes();
  },
  watch: {
    perfilEscolhido(vNew) {
      this.escolaEscolhido = null;
      if (vNew != "0") this.getEscolas();
    }
  },
  validations() {
    return {
      escolaEscolhido: { required: this.exibir ? required : "" },
      perfilEscolhido: { required },
      anoEscolhido: { required: requiredIf( () => this.exibirListaAno === true ) }
    };
  },
  methods: {
    async getQuantidadeNotificacoes() {
      const { data } = await NotificacaoRepository.getQuantidadeNotificacoes( { cdtipesc: this.school.cdtipesc , cdescola: this.school.cdescola, cdpessoalatribuido: this.userProfessor.cdpessoal, cdmatricatribuido: this.userProfessor.cdmatric } );
      this.quantidade_notificacoes = data.quantidade;
    },
    async alterarAcesso() {
      this.desabilitarBotaoSettingsPerfil = true;
      this.perfilEscolhido = this.profile;
      this.anoEscolhido = this.getAnoSistema;
      await this.getEscolas();
      if (this.exibir) {
        this.escolaEscolhido = JSON.stringify(this.school);
      }
    },
    async getEscolas() {
      const { data } = await AuthRepository.getListSchools({
        identificadorusuarioperfil: this.perfilEscolhido
      });
      this.escolas = data.results.escolas;
      this.exibir = this.escolas.length > 0;

    },
    mudarAno() {
      this.escolaEscolhido = null;
    },
    cancelarMudarPerfil() {
      this.desabilitarBotaoSettingsPerfil = false;
      this.menu = false;
      this.$v.$reset();
    },
    async onSubmit() {
      this.desabilitarBotaoSettingsPerfil = false;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.perfilEscolhido != "0") {
        if (this.exibir && this.escolaEscolhido != 0) {
          let escola = JSON.parse(this.escolaEscolhido);
          if (this.perfilEscolhido != this.profile) {
            await this.alterar_perfil(parseInt(this.perfilEscolhido));
          }
          await this.alterarEscola(escola);
          await this.inserirAno(this.anoEscolhido);
        } else if (!this.exibir) {
          if (this.perfilEscolhido != this.profile) {
            await this.alterar_perfil(parseInt(this.perfilEscolhido));
          }

          await this.alterarEscola(null);
          await this.inserirAno(this.anoEscolhido);
        } else {
          return false;
        }

        this.menu = false;
        this.$router.push("/");

        if ( this.userDadosPerfilAtual.identificadorperfil == 2 )
          this.getQuantidadeNotificacoes();
      }
    },
    ...mapActions(["alterar_perfil", "alterarEscola", "inserirAno"])
  },
  computed: {
    ...mapGetters([
      "profile_name",
      "username",
      "schoolName",
      "profiles",
      "profile",
      "school",
      "userPerfilTelas",
      "email",
      "avatar",
      "getAnoSistema",
      "getAnoAtualServidor",
      "getAnoInicioSistema",
      "getAnoSistema",
      "userProfessor",
      "userDadosPerfilAtual",
    ]),
    exibirListaAno() {
      return this.getAnoSistema !== null && this.getAnoInicioSistema !== null
    },
    optionsEscolas() {
      let options = [];
      options.push({ text: "Escolha abaixo...", value: 0 });
      for (var key in this.escolas) {
        if (
          !this.escolas[key].anos ||
          (this.escolas[key].anos && this.escolas[key].anos.indexOf(this.anoEscolhido) >= 0)
        ) {
          options.push({
            text: this.escolas[key].nmescola,
            value: JSON.stringify(this.escolas[key])
          });
        }
      }
      return options;
    },
    optionsPerfis() {
      let options = [];
      for (var key in this.profiles) {
        // const text = `${this.profiles[key].nomeperfil} ${(this.isVariasMatriculas)? ` - Matrícula: ${this.profiles[key].cdmatric}` : ''}`;
        const text = `${this.profiles[key].nomeperfil} ${` - Matrícula: ${
          this.profiles[key].cdpessoal
        }-${this.profiles[key].cdmatric}`}`;
        options.push({
          text,
          value: this.profiles[key].identificadorusuarioperfil
        });
      }
      return options;
    },
    optionsAno() {
      if (!this.getAnoInicioSistema || !this.getAnoAtualServidor) {
        return [];
      }
      let retornoOptions = [];
      for (let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
    isVariasMatriculas() {
      return this.profiles.filter(key => key.identificadorperfil == 2).length > 1;
    }
  }
};
</script>


<style lang="scss" >

.container.container_principal {
  padding: 25px;
}

/* Largura da barra de rolagem */
::-webkit-scrollbar {
  width: 5px;
}

/* Fundo da barra de rolagem */
::-webkit-scrollbar-track-piece {
  background-color: #eee;
  border-left: 1px solid #ccc;
}

/* Cor do indicador de rolagem */
::-webkit-scrollbar-thumb:vertical,
::-webkit-scrollbar-thumb:horizontal {
  background-color: #bac0c4;
}

/* Cor do indicador de rolagem - ao passar o mouse */
::-webkit-scrollbar-thumb:vertical:hover,
::-webkit-scrollbar-thumb:horizontal:hover {
  background-color: #717171;
}

.app-nav {
  text-align: center;
}
.app-nav img {
  margin-top: 4px;
}
.border-avatar {
  border: 2px solid #508fbf;
}

.v-list-group, .v-list {
cursor: pointer;
}

.v-list-item .v-list-item__subtitle, .v-list-item .v-list-item__title {
    line-height: 1.0;
}

.nivel1 {

border-bottom: 1px solid #2b6790;
  .v-list-item__title {
    line-height: 1.0;
    /* background-color: red; */
    font-size: 14px;
  }

}

.v-list {
  padding: 0;
}



.nivel {
  background-color: #508FBF;
}

.subnivel {
  background-color: #5492c1;
  padding: 0;


  &:hover {
    background-color: #619BC6;
  }

}

.nivelBranco {
  background-color: #FFF;
  color: black;
}

.label_dialog {
  color: cadetblue;
  font-weight: 900;
  font-size: 16px;

}

.menu-footer {
  position: fixed !important;
  bottom: 0px !important;
  width:100% !important;
  height: 60px !important;
  background-color: #015d89 !important;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
}
.menu-footer div {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  letter-spacing: 1.1px;
  font-size: 0.8em;
}

</style>
